import { useEffect } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import "./styles/index.scss";
import Routing from "./Routes";
import { requestPermission, getMessage } from "./utils/firebase";

function App() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(function (registration) {
          console.log("ServiceWorker registration successful with scope: ", registration.scope);
        })
        .catch(function (err) {
          console.error("ServiceWorker registration failed: ", err);
        });
    });
  }

  useEffect(() => {
    const FCMTOKEN = localStorage.getItem("fcmToken");
    const token = localStorage.getItem("@secure.s.TOKEN");
    if (token) {
      if (!FCMTOKEN) {
        requestPermission();
      }
    }
    getMessage();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routing />
    </ThemeProvider>
  );
}

export default App;
